export const SORT_DIRECTIONS = {
  ASCENDING: '1',
  DESCENDING: '-1',
};

export const FILTER_OPTIONS = {
  ALL: {
    value: 'all',
    label: 'All',
    group: 'all',
  },
  PAID: {
    value: 'paid',
    label: 'Paid',
    group: 'success',
  },
  PARTIALLY_PAID: {
    value: 'partially_paid',
    label: 'Partially paid',
    group: 'success',
  },
  RECOVERED: {
    value: 'recovered',
    label: 'Recovered',
    group: 'success',
  },
  UNPAID: {
    value: 'unpaid',
    label: 'Unpaid',
    group: 'pending',
  },
  INCOMPLETE: {
    value: 'incomplete',
    label: 'Incomplete',
    group: 'pending',
  },
  REFUNDED: {
    value: 'refunded',
    label: 'Refunded',
    group: 'pending',
  },
  PARTIAL_REFUND: {
    value: 'partial_refund',
    label: 'Partial refund',
    group: 'pending',
  },
  ABANDONED: {
    value: 'abandoned',
    label: 'Abandoned',
    group: 'pending',
  },
  FAILED: {
    value: 'failed',
    label: 'Failed',
    group: 'failed',
  },
  CANCELED: {
    value: 'canceled',
    label: 'Canceled',
    group: 'failed',
  },
};

export const BOOKINGS_LIST_ORDER_STATUS = 'with_canceled';

const { ALL, PAID, ABANDONED, ...REMAINING_FILTER_OPTIONS } = FILTER_OPTIONS;

// Only event bookings can be complimentary or archived, so those options stay off FILTER_OPTIONS.
// The 'hidden' group sits under a separator: the buckets the default bookings view leaves out.
export const BOOKING_FILTER_OPTIONS = {
  ALL: { ...ALL, label: 'All statuses' },
  PAID,
  COMPLIMENTARY: {
    value: 'complimentary',
    label: 'Complimentary',
    group: 'success',
  },
  ...REMAINING_FILTER_OPTIONS,
  ABANDONED: { ...ABANDONED, group: 'hidden' },
  ARCHIVED: {
    value: 'archived',
    label: 'Archived',
    group: 'hidden',
  },
};

export const COUPON_FILTER_OPTIONS = {
  ALL: {
    value: 'all',
    label: 'All',
  },
  PAID: {
    value: 'paid',
    label: 'Paid',
  },
  PARTIALLY_PAID: {
    value: 'partially_paid',
    label: 'Partially paid',
  },
  RECOVERED: {
    value: 'recovered',
    label: 'Recovered',
  },
  UNPAID: {
    value: 'unpaid',
    label: 'Unpaid',
  },
  REFUNDED: {
    value: 'refunded',
    label: 'Refunded',
  },
  PARTIAL_REFUND: {
    value: 'partial_refund',
    label: 'Partial refund',
  },
  CANCELED: {
    value: 'canceled',
    label: 'Canceled',
  },
};
